import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Button, Select, MenuItem, Checkbox, ListItemText } from '@material-ui/core';
import MaterialTable from 'material-table';

import ghaDashboardStyles from './ghaDashboard.module.css';
import commonStyles from '../../common/common.module.css';

import waitlist from '../../../assets/userWaitlist.svg';
import time from '../../../assets/time.svg';
import serving from '../../../assets/group.svg';
import Logo from '../../../assets/FD_Logo.png';
import SideBarContainer from '../../sideBar/SideBarContainer';
import DriverQueue from '../../../models/DriverQueue';
import ServingComponent from './ServingComponent';
import Counter from '../../../models/Counter';

const styles = (theme: Theme) =>

  createStyles({
    select: {
      width: '25%'
    }
  });

interface GhaDashboardProps {
  classes: any;
  filterOrderType: (type: string) => void;
  queue: Array<DriverQueue>;
  serving: Array<DriverQueue>;
  waitTime: number;
  type: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  counters: Array<Counter>;
  countersSelected: Array<number>;
  counterData: Array<string>;
};

const PADDING_RIGHT_CELLS = '14px';
const PADDING_LEFT_CELLS = '10px';
const cellStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };


const ghaDashboard = (props: GhaDashboardProps) => {
  
  const { innerWidth, innerHeight } = window;
  const { classes } = props;

  const counters = props.counters.map((option: Counter, index: number) => {
    return (
      <MenuItem key={ index } value={ option.id } className={ classes.menuItem }>{ option.name }</MenuItem>
    )
  });

  return (
    <div>
         
      <div className={ `${ commonStyles.mt4 } ${ commonStyles.mb3 }` }>
        <div className={ `${ commonStyles.fSpaceBtw } ${ commonStyles.flexWrap } ${ commonStyles.gap20 }` }>
          <div className={ `${ commonStyles.fRow } ${ ghaDashboardStyles.iconwrapper }` }>
            <div className={ `${ ghaDashboardStyles.dashHeadWrapper }` }>
              <img src={waitlist} alt='bulb' className={ `${ ghaDashboardStyles.dashHeadImg }` } />
              <p className={ `${ ghaDashboardStyles.dashHeadLabel }` }>waitlist</p>
            </div>
              <p className={ `${ ghaDashboardStyles.digit }` }>{ props.queue ? props.queue.length : 0 }</p>
          </div>
          <div className={ `${ commonStyles.fRow } ${ ghaDashboardStyles.iconwrapper }` }>
            <div className={ `${ ghaDashboardStyles.dashHeadWrapper }` }>
              <img src={time} alt='bulb' className={ `${ ghaDashboardStyles.dashHeadImg }` } />
              <p className={ `${ ghaDashboardStyles.dashHeadLabel }` }>avg wait time</p>
            </div>
              <p className={ `${ ghaDashboardStyles.digit }` }>{ Math.floor(props.waitTime) }<small className={ ghaDashboardStyles.minsText }>mins</small></p>
          </div>
          <div className={ `${ commonStyles.fRow } ${ ghaDashboardStyles.iconwrapper }` }>
            <div className={ `${ ghaDashboardStyles.dashHeadWrapper }` }>
              <img src={serving} alt='bulb' className={ `${ ghaDashboardStyles.dashHeadImg }` } />
              <p className={ `${ ghaDashboardStyles.dashHeadLabel }` }>now serving</p>
            </div>
              <p className={ `${ ghaDashboardStyles.digit }` }>{ props.serving ? props.serving.length : 0}</p>
          </div>
        </div>
      </div>
      <Grid container spacing={3} className={ ghaDashboardStyles.mainGridContainer }>
        <Grid item xs={12} sm={12} md={12} lg={8} className={ commonStyles.h100 }>
          <div className={ `${ commonStyles.wrapper } ${ ghaDashboardStyles.wrapper }` }>
            <h3 className={ `${ commonStyles.header } ${ ghaDashboardStyles.header }` } > Waiting List</h3>
            <div className={ classes.space }></div>
            <MaterialTable
              components={{Container: props => <Paper {...props} elevation={0} className={ `${ commonStyles.paperTable } ${ ghaDashboardStyles.tableWrapper }` }/>}}

              data={props.queue}  

              columns={[
                { title: 'Order', field: 'order', cellStyle: { backgroundColor: 'var(--primaryblue)', width: '5%' }, headerStyle, 
                  render: (rowData: any) => {
                    return <div className={ ghaDashboardStyles.listNum }>{ rowData.sr_no }</div>;
                  } 
                },
                { title: 'Order', field: 'name', cellStyle, headerStyle, 
                  render: (rowData: any) => {
                    return <div>{ `${rowData.info.first_name} ${rowData.info.last_name}` }</div>;
                  } 
                },
                { title: 'Order', field: 'company', cellStyle, headerStyle, 
                  render: (rowData: any) => {
                    return <div>{ `${rowData.info.company}` }</div>;
                  } 
                },
                { title: 'Order', field: 'pickup', cellStyle, headerStyle, 
                  render: (rowData: any) => {
                    return <div>{ `${rowData.info.type === 'export' ? 'Drop Off' : 'Pick Up'}` }</div>;
                  } 
                },
                {
                  title: 'Airlines',
                  field: 'airlines',
                  cellStyle,
                  headerStyle,
                  render: (rowData: any) => {
                    return (
                      <div>
                        {rowData.info && rowData.info.airlines ? (
                          rowData.info.airlines.join(', ')
                        ) : (
                          <span>N/A</span>
                        )}
                      </div>
                    );
                  },
                },
                { title: 'Order', field: 'appointment', cellStyle, headerStyle, 
                  render: (rowData: any) => {
                    return <div>{ rowData.info.appointment ? `Appointment at ${ rowData.info.appointmentTime } - ${ rowData.info.orderNumber }` : 'Walk In' }</div>;
                  } 
                },
              ]}

              options={{
                paging: false,
                showFirstLastPageButtons: false,
                paginationType: 'normal',
                pageSize: Math.round(innerHeight/ 100), 
                headerStyle: {
                  backgroundColor: 'var(--tbl_head_bkg)',
                  color: 'var(--tbl_head_color)',
                  zIndex: 2,
                  display: 'none'
                },
                maxBodyHeight: 'calc(100vh - 310px)',
                showTitle: false,
                toolbar: false,
                sorting: false
              }}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4} className={ commonStyles.h100 }>
          <ServingComponent 
            serving={ props.serving }
            type={ props.type }
          />
        </Grid>
      </Grid>
 
      <div className={ `${ commonStyles.fSpaceBtw }` }>
        <SideBarContainer button={ true } />
        { props.counters.length && props.countersSelected && <div className={` ${ commonStyles.inputLabelWrapper } ${ commonStyles.mb3 } ${ classes.select }`}>
          <label className={ commonStyles.inputLabel }> Select Counter </label>
          <Select
            variant="outlined"
            className={ classes.overrideBorder }
            multiple
            value={ props.countersSelected || [] }
            onChange={(event: any) => props.handleChange(event)}
            renderValue={(selected: any) => {
              if (Array.isArray(selected) && selected.length === props.counters.length) {
                return 'All Counters';
              }
              const selectedNames = selected.map((counterId: number) => {
                const counter = props.counters.find((option) => option.id === counterId);
                return counter ? counter.name : '';
              });
              return selectedNames.join(', ');
            }}
          >
            <MenuItem value="selectAll" className={classes.menuItem}>
              <Checkbox
                checked={
                  Array.isArray(props.countersSelected) &&
                  props.countersSelected.length === props.counters.length
                }
              />
              <ListItemText primary="Select All" />
            </MenuItem>
            <MenuItem value="deselectAll" disabled={props.countersSelected.length === 0}>
              <ListItemText primary="Deselect All" />
            </MenuItem>
            { counters }
          </Select>
        </div>}
        <img src={Logo} alt='logo' className={ `${ ghaDashboardStyles.logo }` } />
      </div>
      
    </div>
  );
};

export default withStyles(styles)(ghaDashboard);